import React, {Component, PropTypes} from 'react'
import {findDOMNode} from 'react-dom'
import {Button} from 'react-bootstrap'

class LoaderButton extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {}
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.loading != this.props.loading) {
            const {loading} = nextProps
            const element = findDOMNode(this)

            this.setState({
                loading: loading,
                width: loading && (element.offsetWidth - 1) || null
            })
        }
    }

    _onClick(event) {
        const {onClick} = this.props

        const result = onClick(event)
        if (result && (typeof result.then == 'function')) {
            const promise = result
            const element = findDOMNode(this)

            this.setState({
                loading: true,
                width: element.offsetWidth - 1 
            })

            promise.then(() => {
                this.setState({
                    loading: false,
                    width: null
                })
            }).catch(() => {
                this.setState({
                    loading: false,
                    width: null
                })
            })
        }
    }

    render() {
        const {children, disabled, onClick, ...others} = this.props
        const {loading, width} = this.state

        const defaultStyle = {width}

        return (
            <Button
                style={defaultStyle}
                disabled={loading || disabled}
                onClick={(e) => this._onClick(e)}
                {...others}>
                {loading && (
                    <span>...</span>
                ) || children}
            </Button>
        )
    }
}

export default LoaderButton


// WEBPACK FOOTER //
// ./lib/core/components/LoaderButton.js